module.exports = {
  localeName: 'it-IT',
  momentFormat: 'DD/MM/YYYY',
};
